"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = exports.Wrapper = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var theme_1 = require("../../../theme");
var VerticalSpacer_1 = __importDefault(require("../../utils/VerticalSpacer"));
var TextButton_1 = __importDefault(require("../TextButton"));
exports.Wrapper = (0, styled_components_1.default)(VerticalSpacer_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  padding: ", ";\n  border-radius: 10px;\n"], ["\n  background-color: ", ";\n  padding: ", ";\n  border-radius: 10px;\n"])), function (_a) {
    var $backgroundColor = _a.$backgroundColor;
    return $backgroundColor ? theme_1.theme.colors[$backgroundColor] : '';
}, function (_a) {
    var $backgroundColor = _a.$backgroundColor;
    return ($backgroundColor ? '24px' : '');
});
exports.Header = (0, styled_components_1.default)(TextButton_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n"], ["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n"])));
var templateObject_1, templateObject_2;
